var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart body__extrasmall"},[_c('div',{staticClass:"left"},[_vm._v("next status")]),_c('div',{staticClass:"right",style:(_vm.widthPrecent)},[_vm._v("total "+_vm._s(_vm.total))])])
}
var staticRenderFns = []

export { render, staticRenderFns }